export default {

	createAdditionalInfo(options) {
		let width = 240
		let height = 75

		var rect = new fabric.Rect({
			width: width,
			height: height,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 1,
			rx: 3,
			ry: 3,
		});

		let title = this.addTitle(width / 2)
		let textGroup = this.addTexts(options.information)

		var group = new fabric.Group([rect, title, textGroup], {
			type: 'additionalInfo',
			left: options.pageWidth - width - 20,
			top: options.pageHeight - height - 115,
		});

		return group
	},

	/**
	 * Adds the scale title
	 */
	addTitle(center) {
		return new fabric.Text("Information", {
			originX: 'center',
			left: center,
			top: 5,
			fontSize: 15,
			fontFamily: 'Helvetica'
		});
	},

	addTexts(information) {
		let infoTexts = Object.keys(information.entries).map(key => {
			if(information.entries[key].enabled) {
				return information.entries[key].content
			}
		})

		let texts = []
		let currentTop = 30
		infoTexts.forEach(entry => {
			texts.push(new fabric.Text(entry, {
				top: currentTop,
				breakWords: true,
				originX: 'left',
				left: 15,
				fontSize: 12,
				fontFamily: 'Helvetica'
			}))
			currentTop += 20
		});

		return new fabric.Group(texts)
	},

}